import { FormControlLabel, Radio, RadioGroup, styled } from "@mui/material";

import LabelForm from "../Form/Label";
import GenericModal from "../Generic/Modal";

export const Modal = styled(GenericModal)(() => ({
  // minWidth: "90vw",
}));

export const RadioButton = styled(Radio)(() => ({
  color: "#D0D5DD",

  "&.Mui-checked": {
    color: "#308CDB",
  },
}));

export const RadioLabel = styled(FormControlLabel)(() => ({
  "& .MuiFormControlLabel-label": {
    fontFamily: "Manrope, sans-serif",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "0.875rem",
    color: "#465869",
  },
}));

export const FormLabel = styled(LabelForm)(() => ({
  color: "#308CDB",
  lineHeight: "1.5rem",
  fontWeight: 600,
  marginBottom: "24px",
  fontFamily: "Manrope",
}));

export const StyledRadioGroup = styled(RadioGroup)(() => ({
  display: "flex",
  flexDirection: "row",
}));
